import { BillingRateType } from 'src/app/facility-contracts/facilities/models/billing-rate-type.enum';
import { FacilityExpertise } from 'src/app/facility-contracts/facilities/models/facility-expertise.model';

export class FacilityProfession {
    id: number;
    facilityId: number;
    billingRateType: BillingRateType;
    localTraveler: boolean;
    assignmentLengthFrom: number;
    assignmentLengthTo: number;
    rangeBilling: boolean;
    professionId: number;
    createdDate: Date;
    modifiedDate: Date;
    expertises: FacilityExpertise[];
}
